<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('finance') }}
    </h1>
    <div class="main__body">
      <div class="account__balance">
        <div class="account__balance-header">
          {{ $t('balance') }}
        </div>
        <div class="account__balance-sum">
          {{ this.finance.balance }} {{ $t('rub') }}
        </div>
        <div class="account__balance-deposit">
          <a class="btn btn-secondary" @click="showPaymentModal">{{ $t('deposit') }}</a>
        </div>
      </div>
      <div class="account__mailing-cost">
        <div class="account__mailing-header">
          {{ $t('mailing-cost') }}
        </div>
        <div class="cost-item">
          <div class="cost-item_name">
            Sms
          </div>
          <div class="cost-item_price">
            {{ this.finance.sms }}
          </div>
        </div>
        <div class="cost-item">
          <div class="cost-item_name">
            Email
          </div>
          <div class="cost-item_price">
            {{ this.finance.email }}
          </div>
        </div>
        <div class="cost-item">
          <div class="cost-item_name">
            Telegram
          </div>
          <div class="cost-item_price">
            {{ this.finance.telegram }}
          </div>
        </div>
        <div class="cost-item">
          <div class="cost-item_name">
            Viber
          </div>
          <div class="cost-item_price">
            {{ this.finance.viber }}
          </div>
        </div>
      </div>
      <div class="account__expenses">
        <div class="account__expenses-header">
          {{ $t('expenses') }}
        </div>
        <div class="account-expenses-search">
          <div class="form-row">
            <div class="form-group">
              <label>{{ $t('select') }} {{ $t('period') }} {{ $t('from') }}</label>
              <input type="date" v-model="filter.afterDate" @change="this.filterFinance" lang="fr-CA">
            </div>
            <div class="form-group">
              <label>{{ $t('select') }} {{ $t('period') }} {{ $t('before') }}</label>
              <input type="date" v-model="filter.beforeDate" @change="this.filterFinance">
            </div>
          </div>
        </div>
        <div class="account-expenses-history">
          <table class="table table-striped">
            <thead>
            <tr>
              <th scope="col"></th>
              <th scope="col">{{ $t('sent-mail') }}</th>
              <th scope="col">{{ $t('for-amount') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th scope="row">SMS</th>
              <td>{{ this.resultFilter.messageSms }}</td>
              <td>{{ this.resultFilter.amountSms.toFixed(2) }}</td>
            </tr>
            <tr>
              <th scope="row">Email</th>
              <td>{{ this.resultFilter.messageEmail }}</td>
              <td>{{ this.resultFilter.amountEmail.toFixed(2) }}</td>
            </tr>
            <tr>
              <th scope="row">Telegram</th>
              <td>{{ this.resultFilter.messageTelegram }}</td>
              <td>{{ this.resultFilter.amountTelegram.toFixed(2) }}</td>
            </tr>
            <tr>
              <th scope="row">Viber</th>
              <td>{{ this.resultFilter.messageViber }}</td>
              <td>{{ this.resultFilter.amountViber.toFixed(2) }}</td>
            </tr>
            <tr>
              <th scope="row">{{ $t('total') }}:</th>
              <td>{{ this.resultFilter.allMessageCount }}</td>
              <td>{{ this.resultFilter.allMessageAmount.toFixed(2) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <payment-modal v-show="isModalPaymentVisible"
                   @close="closePaymentModal"></payment-modal>
  </div>
</template>

<style scoped>

.cost-item_header.wh-nowrap{
  white-space: nowrap;
}

.cost-item_header{
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
  line-height: 135%;
  text-align: center;
  letter-spacing: 0.05em;
  color: #000000;
}

.cost-item_header:first-child{
  min-width: 55px;
}

.account__expenses .account-expenses-search{
  margin-top: 10px;
}
.account__expenses .account__expenses-header{
  font-weight: bold;
  font-size: 20px;
  line-height: 135%;
  letter-spacing: 0.05em;
  color: #000000;
}
.account__expenses{
  margin-top: 70px;
}
.account__mailing-cost{
  margin-top: 40px;
}

.account__mailing-cost .account__mailing-header{
  font-weight: bold;
  font-size: 20px;
  line-height: 135%;
  letter-spacing: 0.05em;
  color: #000000;
}

.cost-item{
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  max-width: 142px;
}

.cost-item.large-header{
  max-width: 310px;
}

.cost-item.large-text{
  max-width: 295px;
}

.cost-item .cost-item_name{
  font-size: 14px;
  line-height: 145%;
  color: #4F4F4F;
  max-width: 30px;
}

.cost-item .cost-item_price, .cost-item .cost-item_count{
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  color: #000000;
}

.cost-item .cost-item_name-all, .cost-item .cost-item_price-all, .cost-item .cost-item_count-all{
  font-weight: bold;
  font-size: 16px;
  line-height: 135%;
  text-align: center;
  letter-spacing: 0.05em;
  color: #000000;
  max-width: 30px;
}

.account__balance{
  background: rgba(233, 159, 84, 0.1);
  border: 1px dashed #E99F54;
  box-sizing: border-box;
  border-radius: 20px;
  padding: 10px 0 10px 0;
  max-width: 430px;
  height: 203px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.account__balance .account__balance-header{
  font-weight: bold;
  font-size: 20px;
  line-height: 135%;
  letter-spacing: 0.05em;
  color: #484848;
}
.account__balance .account__balance-sum{
  font-weight: bold;
  font-size: 20px;
  line-height: 135%;
  letter-spacing: 0.05em;
  color: #484848;
}
</style>

<script>
import axios from 'axios'
import paymentModal from "../components/modal/paymentModal";
export default {
  name: 'finance',
  data: function () {
    return {
      finance: {
        balance: '',
      },
      filter: {
        afterDate: null,
        beforeDate: null,
      },
      resultFilter: {
        allMessageAmount: 0,
        allMessageCount: 0,
        messageEmail: 0,
        messageSms: 0,
        messageTelegram: 0,
        messageViber: 0,
        amountTelegram: 0,
        amountViber: 0,
        amountSms: 0,
        amountEmail: 0,
      },
      isModalPaymentVisible: false,
    }
  },
  created() {
    this.getUserInfo();
    this.filterFinance();
  },
  methods: {
    getUserInfo: function () {
      axios.post('getUser').then(response => {
        var status = response.data.status;
        if (status) {
          this.finance = response.data.user;
        }
      });
    },
    filterFinance: function(){
      axios.post('filterFinance', this.filter).then(response => {
        var status = response.data.status;
        if (status) {
          this.resultFilter.allMessageAmount = response.data.allMessageAmount;
          this.resultFilter.allMessageCount = response.data.allMessageCount;
          this.resultFilter.messageEmail = response.data.messageEmail;
          this.resultFilter.messageSms = response.data.messageSms;
          this.resultFilter.messageTelegram = response.data.messageTelegram;
          this.resultFilter.messageViber = response.data.messageViber;
          this.resultFilter.amountTelegram = response.data.amountTelegram;
          this.resultFilter.amountViber = response.data.amountViber;
          this.resultFilter.amountSms = response.data.amountSms;
          this.resultFilter.amountEmail = response.data.amountEmail;
        }
      });
    },
    showPaymentModal() {
      this.isModalPaymentVisible = true;
    },
    closePaymentModal() {
      this.isModalPaymentVisible = false;
    },
  },
  components: {
    paymentModal
  }
}
</script>